export default __webpack_public_path__ + "static/media/app.035afd10.jpg";